import React, { useState } from 'react';
import { Button, Divider, Result, Row, Tabs } from 'antd';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { useTranslation } from 'react-i18next';

// import '@ant-design/compatible/assets/index.css';


import CustomAddNewPageContent from '../../../components/Content/CustomAddNewPageContent';
import General from './tabs/General';
import { savePoiGroupAction } from '../../../actions/AppCms/PoiGroupActions';
import { history } from '../../../utils/history';

const { TabPane } = Tabs;

function callback(key) {

}

const AddPoiGroup = ({ form }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [finished, setFinished] = useState(false);

  const handleGoReports = () => {
    history.push('/poi-groups');
  };

  const handleGoAddNew = () => {
    window.location.reload();
  };

  const handleSubmit = e => {
    e.preventDefault();
    // const { form } = this.props;
    form.validateFieldsAndScroll((err, fieldsValue) => {
      if (!err) {
        const values = {
          title: fieldsValue.title,
          image: fieldsValue.image ? fieldsValue.image[0] : null,
        };

        dispatch(savePoiGroupAction(values)).then(() => {
          setFinished(true);
        });
      }
    });
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 },
      lg: { span: 10 },
      xl: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
      md: { span: 24 },
      lg: { span: 12 },
      xl: { span: 12 },
    },
  };

  return (
    (<CustomAddNewPageContent
      title={t('appCms.poiGroup.addPoiGroup')}
      subTitle={t('appCms.poiGroup.pointOfInterestGroup')}
    >
      {!finished && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        (<Form {...formItemLayout} onSubmit={handleSubmit}>
          <Tabs onChange={callback}>
            <TabPane tab={t('appCms.general')} key="1">
              <General form={form} submit={null} />
            </TabPane>
          </Tabs>
          <Divider />
          <Row type="flex" justify="center">
            <Button type="primary" htmlType="submit">
              {t('common.save')}
            </Button>
          </Row>
        </Form>)
      )}
      {finished && (
        <Result
          status="success"
          title={t('appCms.poiGroup.successfullySaved')}
          extra={[
            <Button type="primary" key="console" onClick={handleGoReports}>
              {t('appCms.poiGroup.goToPoiGroups')}
            </Button>,
            <Button key="buy" onClick={handleGoAddNew}>
              {t('appCms.poiGroup.addPoiGroup')}
            </Button>,
          ]}
        />
      )}
    </CustomAddNewPageContent>)
  );
};

AddPoiGroup.propTypes = {
  form: PropTypes.object,
  savePoiGroupAction: PropTypes.func,
  match: PropTypes.object,
};

const WrappedPoiGroupForm = Form.create({
  name: 'WrappedPoiGroup',
})(AddPoiGroup);

function mapStateToProps() {
  return {};
}

const WrappedAddPoiGroup = connect(mapStateToProps, {
  savePoiGroupAction,
})(WrappedPoiGroupForm);

export default WrappedAddPoiGroup;
